import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import pdfIcon from "../../assets/img/investor-relations/pdf-icon.svg"; 
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import * as apiUrl from "../../apiUrl";

function InvestorDescription() {
  const [InvestorDescription, setInvestorDescription] = useState([]);

  useEffect(() => {
    const fetchInvestorDescription = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/invetors-relation/investor-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setInvestorDescription(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchInvestorDescription();
  }, []);

  const firstCards = InvestorDescription.first_tab_details
    ? JSON.parse(InvestorDescription.first_tab_details)
    : [];

  const secondCards = InvestorDescription.second_tab_details
    ? JSON.parse(InvestorDescription.second_tab_details)
    : [];

  return (

    <section className="investor-desc-sec">
      <Container fluid>
        <Row className="flex-center investor-content-row">
          <Col md={12} className="padding-zero">
            <Tabs
              defaultActiveKey={InvestorDescription.first_tab_title}
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab
                eventKey={InvestorDescription.first_tab_title}
                title={InvestorDescription.first_tab_title}
              >
                <div className="investor-card-row">
                  <Row>
                    {firstCards.map((card, index) => (
                      <Col md={4} key={index}>
                        <div className="investor-card">
                          <img
                            src={pdfIcon}
                            className="img-fluid"
                            alt="PDF Icon"
                          />
                          <h4 className="luxury-font">{card.card_title}</h4>
                          <span>Published On {card.date}</span>
                          <a
                            href={`${apiUrl.apiUrl}/${card.file}`}
                            className="download-btn"
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download
                          </a>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Tab>

              <Tab
                eventKey={InvestorDescription.second_tab_title}
                title={InvestorDescription.second_tab_title}
              >
                <div className="investor-card-row">
                  <Row>
                    {secondCards.map((card, index) => (
                      <Col md={4} key={index}>
                        <div className="investor-card">
                          <img
                            src={pdfIcon}
                            className="img-fluid"
                            alt="PDF Icon"
                          />
                          <h4 className="luxury-font">{card.card_title_1}</h4>
                          <span>Published On {card.date_1}</span>
                          <a
                            href={`${apiUrl.apiUrl}/${card.file_1}`}
                            className="download-btn"
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download
                          </a>
                        </div>
                      </Col>
                    ))}

                  </Row>
                </div>
              </Tab>
            </Tabs>
          </Col>

        </Row>
      </Container>
    </section>
  );
}

export default InvestorDescription;
